export function BodyText(props: any) {
  const style = { fontFamily: "helvetica-light", fontSize: "16px", lineHeight: "25px" };
  return <div {...props} style={style} />;
}